import script from "./TermsIncUk.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsIncUk.vue?vue&type=script&setup=true&lang=ts"

import "./TermsIncUk.vue?vue&type=style&index=0&id=2ea79c80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea79c80"]])

export default __exports__